import CoreDrawer from '@/components/CoreDrawer';
import { useHandleActionItem } from '@/components/hooks/useHandleActionItem';
import { Spin, Typography } from 'antd';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import useViewModel from '../../viewmodels/detail';
import { AccountForm } from './AccountForm';
import { get } from 'lodash';

interface Props {
  open: boolean;
  handleClose: () => void;
  setOpen: (value: boolean) => void;
}

export const Detail: React.FC<Props> = (props: Props): JSX.Element => {
  const { open, setOpen, handleClose } = props;
  const { loading, error, detail, actionGetDetail } = useViewModel();

  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const getAction = currentQueryParameters.get('action');

  useEffect(() => {
    if ((showId !== null && getAction === 'Detail') || getAction === 'Create') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [open, handleClose, setOpen]);

  useEffect(() => {
    if (showId) {
      actionGetDetail();
    }
  }, [open]);

  const renderContent = () => {
    if (showId) {
      return (
        <>
          <div>{loading && <Spin />}</div>
          {error && <div>Error</div>}
          {!error && !loading && detail.data.id !== '' && (
            <AccountForm detailAccount={detail.data} openForm={open} showId={showId} />
          )}
        </>
      );
    }
    return <AccountForm detailAccount={get(detail, 'data')} openForm={open} showId={showId} />;
  };

  return (
    <CoreDrawer
      open={open}
      onClose={() => handleClose()}
      styles={
        getAction === 'Create' && !showId
          ? { body: { padding: '8px 16px 16px' }, header: { paddingBottom: 8 } }
          : undefined
      }
      title={
        <Typography.Title level={5} className='!mb-0'>
          Accounts
        </Typography.Title>
      }
      content={renderContent()}
    />
  );
};
